import React, {PropTypes} from 'react';
import {connect} from 'react-redux';


// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class Finance extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {
      toggled: false,
    }
	}

	componentDidMount() {
    document.title = 'Diamonds Direct - Special Financing';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  toggleLegal() {
    this.setState({ toggled: true });
  }

	render() {
		return <div className='Finance'>
      <div className='finHeader'>
        <div className='finTitle'>DIAMONDS DIRECT SPECIAL FINANCING<span className='sup'>1,2</span></div>
        <div className='finBr'>
          <img src='https://ddw2.diamondsdirect.com/img/finance/icons/iconline.svg' />
        </div>
        <div className='finIconRow'>
          <div className='finIcon'>
            <div className='finIconImg'>
              <img src='https://ddw2.diamondsdirect.com/img/finance/icons/credit.svg' />
            </div>
            <div className='finIconLabel'>Quick credit decisions</div>
          </div>
          <div className='finIcon'>
            <div className='finIconImg'>
              <img src='https://ddw2.diamondsdirect.com/img/finance/icons/online.svg' />
            </div>
            <div className='finIconLabel'>Convenient online application</div>
          </div>
          <div className='finIcon'>
            <div className='finIconImg'>
              <img src='https://ddw2.diamondsdirect.com/img/finance/icons/account.svg' />
            </div>
            <div className='finIconLabel'>Easy-to-use online account management and bill payment</div>
          </div>
          <div className='finIcon'>
            <div className='finIconImg'>
              <img src='https://ddw2.diamondsdirect.com/img/finance/icons/immediate.svg' />
            </div>
            <div className='finIconLabel'>Immediate access to revolving line</div>
          </div>
          <div className='finIcon'>
            <div className='finIconImg'>
              <img src='https://ddw2.diamondsdirect.com/img/finance/icons/purchase.svg' />
            </div>
            <div className='finIconLabel'>Ability to make repeat purchases</div>
          </div>
        </div>
      </div>
      <div className='finBody'>
        <div className='finBackgroundWrapper'>
          <div className='finBackgroundLeft'>
            <img src='https://ddw2.diamondsdirect.com/img/finance/bgdiamonds.jpg' />
          </div>
          <div className='finBackgroundRight'>
            <img src='https://ddw2.diamondsdirect.com/img/finance/bgring.jpg' />
          </div>
        </div>
        <div className='finCardSection'>
          <div className='finCardLeft'>
            <div className='finCardLeftImageWrapper'>
              <img src='https://ddw2.diamondsdirect.com/img/finance/card.png' />
            </div>
          </div>
          <div className='finCardRight'>
            <div className='finCardRightTextWrapper'>Diamonds Direct credit card issued by Wells Fargo Bank, N.A. is our primary financing option. If approved, you will receive a revolving credit line that you can use immediately. After applying, please choose "Diamonds Direct Credit Card" at checkout.</div>
          </div>
        </div>
        <div className='finColumnsHeader'>
          <div className='finColHeaderTitle'>Current Financing Offers</div>
          <div className='finColHeaderLine'>
            <img src='https://ddw2.diamondsdirect.com/img/finance/icons/iconline.svg' />
          </div>
        </div>
        <div className='finColumnsWrapper'>
          <div className={'finColumn firstCol'}>
            <div className='finColTitle'>No Interest if Paid in Full</div>
            <div className='finColSubtitle'>within 12 Months with Regular Monthly Payments</div>
            <div className={'finColP finPBold'}>Interest will be charged to your account from the purchase date if the purchase balance is not paid in full within the promotional period.<sup>1</sup></div>
            <div className='finColSubtitle'>with minimum purchase amount of $480</div>
            <div className='finColLearnMore' style={{ display: this.state.toggled ? 'none' : 'block'}} onClick={::this.toggleLegal}>Learn More</div>
            <div className='finColP' style={{ display: this.state.toggled ? 'block' : 'none'}}><sup>*</sup>The Diamonds Direct credit card is issued by Wells Fargo Bank, N.A. Special terms apply to qualifying purchases of $480 or more charged with approved credit. Minimum monthly payments are required during the promotional (special terms) period. Interest will be charged to your account from the purchase date at the APR for Purchases if the purchase balance is not paid in full within the promotional period. Paying only the minimum monthly payment will not pay off the purchase balance before the end of the promotional period. For new accounts, the APR for Purchases is 28.99%. If you are charged interest in any billing cycle, the minimum interest charge will be $1.00. This information is accurate as of 08/01/2020 and is subject to change. For current information, call us at <a href='tel:8004315921'>1-800-431-5921</a>. Offer expires 12/31/2022.</div>
          </div>
          <div className='finOr'>or</div>
          <div className='finColumn'>
            <div className='finColTitle'>Special Rate of 9.99% APR</div>
            <div className='finColSubtitle'>with 48 Equal Monthly Payments<sup>2</sup></div>
            <div className='finColLearnMore' style={{ display: this.state.toggled ? 'none' : 'block'}} onClick={::this.toggleLegal}>Learn More</div>
            <div className='finColP' style={{ display: this.state.toggled ? 'block' : 'none'}}><sup>2</sup>The Diamonds Direct credit card is issued by Wells Fargo Bank, N.A. Special terms apply to qualifying purchases charged with approved credit. The special terms APR of 9.99% will apply to the qualifying purchase, and 48 monthly payments equal to 2.5567% of the original special terms balance are required. The advertised terms are an estimate assuming required monthly payments are made on the payment due date; no other balances are currently carried or will be carried on the account; and no additional charges are or will be added to the account. Because your actual account activity may be different than the assumptions used, or because of rounding, the number of payments or the final payment amount could be different than the advertised terms. The special terms APR will continue to apply until all qualifying purchases are paid in full. The APR for Purchases will apply to certain fees such as a late payment fee or if you use the card for other transactions. For new accounts, the APR for Purchases is 28.99%. If you are charged interest in any billing cycle, the minimum interest charge will be $1.00. This information is accurate as of 08/01/2020 and is subject to change. For current information, call us at <a href='tel:8004315921'>1-800-431-5921</a>. Offer expires 12/31/2022.</div>
          </div>
        </div>
        <div className='finBox'>
          <div className={'finBoxLeft finBoxSection'}>
            <div className='finBoxTitle'>Ready to Apply?</div>
            <div className='finBoxCopy'>One easy application process to see if you qualify for financing.</div>
            <div className='finBoxButton' onClick={() => this.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826')}>Apply Now</div>
          </div>
          <div className={'finBoxRight finBoxSection'}>
            <div className='finBoxTitle'>Already Approved?</div>
            <div className='finBoxCopy'>Use the Diamonds Direct credit card to checkout from your cart now.</div>
            <div className='finBoxButton' onClick={() => this.externalNav('checkout/cart')}>Checkout Now</div>
          </div>
        </div>
        <div className='finApply'>
          <div className='finApplyQuestion'>Have questions about applying or using your Diamonds Direct Credit Card?</div>
          <div className='finApplyButton' onClick={() => this.externalNav('contact-us')}>Contact Us</div>
        </div>
        <div className='finLegal' style={{display: 'none'}}><sup>*2</sup>After completing your application, please checkout normally, choosing "Diamonds Direct Credit Card” as your way of payment.</div>
      </div>
		</div>;
	}
}
export default Finance;

function mapStateToProps(state) {
  return {

  };
}

export const FinanceContainer = connect(
  mapStateToProps,
  allActionCreators
)(Finance);


// WEBPACK FOOTER //
// ./src/components/views/finance/Finance.jsx